export default [
    {
        path: 'overview',
        name: 'Overview',
        redirect : "helloworld",
    },
    {
        path: 'helloworld',
        name: 'Hello World',
        component: () => import(/* webpackChunkName: "my-app-helloworld" */ '../views/HelloWorld.vue'),
        meta: {
            mainNavEnabled: true,
        },
    },
    {
        path: 'help',
        name: 'Help',
        component: () => import(/* webpackChunkName: "my-app-help" */ '@/_views/Help.vue'),
    },
]
